import apiOffice from "../axios/apiOffice";

class PaymentMPService {
  static async generatePayment(body) {
    try {
      const response = await apiOffice.post(`/generate-payment-mp`, body);
      if (response.status < 300) {
        return { success: true, data: response.data };
      }
      return {
        success: false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error generating payment:", error);
      return {
        success: false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }

  static async getPaymentState(paymentId,externalReference) {
    try {
      const response = await apiOffice.get(`/payment-state-mp/${paymentId}/${externalReference}`);
      if (response.status < 300) {
        return { success: true, data: response.data };
      }
      return {
        success: false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error getting payment:", error);
      return {
        success: false,
        message: error.response.data?.message || error.message,
        status: error.response?.status || 500,
      };
    }
  }

  static async generatePaymentProcedure(body) {
    try {
      const response = await apiOffice.post(`/preference`, body);
      if (response.status < 300) {
        return { success: true, data: response.data };
      }
      return {
        success: false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error generating payment:", error);
      return {
        success: false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }
}

export default PaymentMPService;
